// extracted by mini-css-extract-plugin
export default {"app":"App_app__PGZgb","heading":"App_heading__vkAQ9","appContainer":"App_appContainer__OGVQM"};